import { cn } from '@/utilities/ui'

import { CategoryLabel } from './common'
import { SeloDestaque } from './SeloDestaque'
import type { DestaquePublicacao } from './types'

/**
 * Linha de categoria das manchetes. Com selo de destaque ativo (R7), o carimbo
 * «Exclusivo»/«Ao vivo» SUBSTITUI a categoria (pedido do dono); sem ele, devolve exatamente o
 * `CategoryLabel` de sempre.
 *
 * O selo é IRMÃO de qualquer link, nunca filho — o rótulo pode ser um `<a>`, e âncora dentro de
 * âncora é HTML inválido.
 */
export function CategoriaComSelo({
  item,
  className,
}: {
  item: DestaquePublicacao
  className?: string
}) {
  // R7 — destaque ativo. Quando a janela fecha, `featuredBadge` some do VM e esta linha volta
  // sozinha a ser a categoria de sempre — nenhum estado a limpar.
  if (item.featuredBadge) {
    return (
      <div className={cn('flex min-w-0 items-center gap-2', className)}>
        <SeloDestaque badge={item.featuredBadge} />
      </div>
    )
  }

  if (!item.category) return null
  return (
    <CategoryLabel href={item.categoryHref} className={className}>
      {item.category}
    </CategoryLabel>
  )
}
